import { IResponseState } from "../../../components/Modals/ResponseModal/module/constants";
import {
  ATTACHMENT_CALL_STATE_IDENTIFIER,
  ATTACHMENT_CALL_STATE_IDENTIFIER_SAVE,
  CANCEL_TAKE_CHARGE_TASK_CALL_STATE,
  SELECTED_TASK_IDENTIFIER,
  SELECTED_TASK_TMP_ATTRIBUTES,
  TAKE_CHARGE_TASK_CALL_STATE,
  TASK_DETAIL_IDENTIFIER,
  TASK_DETAIL_LOADER_IDENTIFIER,
  TASK_LIST_IDENTIFIER,
  TASK_LIST_LOADER,
  TASK_MAIN_CALL_STATE,
  CSV_TASK_LOADED_IDENTIFIER,
  CSV_TASK_LIST_IDENTIFIER,
} from "./constants";

const identifierTasks = {
  [CSV_TASK_LOADED_IDENTIFIER]: false,
  [CSV_TASK_LIST_IDENTIFIER]: [],
  [TASK_LIST_IDENTIFIER]: [],
  [TASK_LIST_LOADER]: false,
  [SELECTED_TASK_IDENTIFIER]: null,
  [SELECTED_TASK_TMP_ATTRIBUTES]: null,
  [TASK_MAIN_CALL_STATE]: IResponseState.PENDING,
  [TASK_DETAIL_IDENTIFIER]: null,
  [TASK_DETAIL_LOADER_IDENTIFIER]: false,
  [TAKE_CHARGE_TASK_CALL_STATE]: IResponseState.PENDING,
  [CANCEL_TAKE_CHARGE_TASK_CALL_STATE]: IResponseState.PENDING,
  [ATTACHMENT_CALL_STATE_IDENTIFIER]: IResponseState.PENDING,
  [ATTACHMENT_CALL_STATE_IDENTIFIER_SAVE]: IResponseState.PENDING,
};

export default identifierTasks;
